import dayjs from 'dayjs';
import { ICustomer } from 'app/shared/model/customer.model';
import { ISupplier } from 'app/shared/model/supplier.model';
import { OrderStatus } from 'app/shared/model/enumerations/order-status.model';
import { ContractType } from 'app/shared/model/enumerations/contract-type.model';
import { SendEmailStatus } from 'app/shared/model/enumerations/send-email-status.model';

export interface ICustomerOrder {
  id?: number;
  orderDate?: dayjs.Dayjs | null;
  desiredDate?: dayjs.Dayjs | null;
  orderStatus?: keyof typeof OrderStatus | null;
  initialFixedAnnualPrice?: number | null;
  initialFixedMonthlyPrice?: number | null;
  contractType?: keyof typeof ContractType | null;
  createdTimestamp?: dayjs.Dayjs | null;
  depositRequired?: boolean | null;
  deposit?: boolean | null;
  offerFilePath?: string | null;
  contractFilePath?: string | null;
  checkSendEmail?: keyof typeof SendEmailStatus | null;
  customer?: ICustomer | null;
  supplier?: ISupplier | null;
}

export const defaultValue: Readonly<ICustomerOrder> = {
  depositRequired: false,
  deposit: false,
};
